import { SchedulePeriodDto } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';

const FULL_WEEKDAY_NAMES = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
const SHORT_WEEKDAY_NAMES = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

function formatHour(time: string): string {
  const match = time.match(/^(\d{2}):(\d{2})/);
  if (!match) {
    return time;
  };
  const [, hours, minutes] = match;
  return minutes === '00' ? `${hours}h` : `${hours}h${minutes}`;
}

function formatDayRanges(weekdays: number[], names: string[]): string {
  const unique = [...new Set(weekdays)];
  const ranges: [number, number][] = [];
  let start = unique[0];
  let prev = unique[0];

  for (let i = 1; i < unique.length; i++) {
    if (unique[i] === prev + 1) {
      prev = unique[i];
    } else {
      ranges.push([start, prev]);
      start = unique[i];
      prev = unique[i];
    }
  }
  ranges.push([start, prev]);

  return ranges
    .map(([s, e]) => (s === e ? names[s] : `${names[s]} a ${names[e]}`))
    .join(', ');
}

export function formatWorkingPeriods(periods: SchedulePeriodDto[]): string {
  if (!periods.length) {
    return '';
  };

  const sorted = [...periods].sort((a, b) => a.weekday - b.weekday);
  const { start: firstStart, end: firstEnd } = sorted[0];
  const allSameHours = sorted.every((p) => p.start === firstStart && p.end === firstEnd);

  if (allSameHours) {
    const days = formatDayRanges(
      sorted.map((p) => p.weekday),
      FULL_WEEKDAY_NAMES,
    );
    return `${days}, ${formatHour(firstStart)} às ${formatHour(firstEnd)}`;
  }

  const groupMap = new Map<string, { weekdays: number[]; start: string; end: string }>();
  for (const p of sorted) {
    const key = `${p.start}-${p.end}`;
    if (!groupMap.has(key)) {
      groupMap.set(key, { weekdays: [], start: p.start, end: p.end });
    }
    groupMap.get(key)!.weekdays.push(p.weekday);
  }

  const groups = [...groupMap.values()].sort((a, b) => a.weekdays[0] - b.weekdays[0]);

  return groups
    .map(({ weekdays, start, end }) => {
      const days = formatDayRanges(weekdays, SHORT_WEEKDAY_NAMES);
      return `${days}: ${formatHour(start)} às ${formatHour(end)}`;
    })
    .join(', ');
}
